<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">

                        <div class="card-header">
                            <h3 class="card-title">LIST USERS ONLINE</h3>
                        </div>
                        <v-app>
                            <v-main>
                                <div class="card-body table-responsive p-2">
                                    <div class="col-sm-12">
                                        <template>
                                            <div class="row">
                                                <div class="col-sm-4">

                                                    <div class="form-group mb-2">
                                                        <KantorCabang v-model="filter.kantor" label="Cabang"
                                                            @input="onFilterChange" class="custom-input" />
                                                    </div>
                                                    <div class="form-group mb-2">
                                                        <v-select v-model="filter.status" label="Semua Status" outlined
                                                            dense clearable class="no-details" :items="[
                                                                { text: 'Online', value: 'online' },
                                                                { text: 'Offline', value: 'offline' },
                                                                { text: 'Suspend/Unpaid', value: 'suspend' }
                                                            ]" item-text="text" item-value="value" @change="onFilterChange" />
                                                    </div>
                                                    <div class="form-group mb-2">
                                                        <TextSearch v-model="filter.search" class="custom-input" label="Cari Nama/ID Pelanggan"
															@input="onFilterChange" />
                                                    </div>
                                                </div>
                                                <div class="col-sm-8">
                                                    <v-row>
                                                        <!-- Info Box 1 -->
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-card class="d-flex align-center pa-3">
                                                                <v-avatar size="40" class="mr-4" color="primary">
                                                                    <v-icon dark>mdi-account</v-icon>
                                                                </v-avatar>
                                                                <div>
                                                                    <div class="subtitle-2">Total Users</div>
                                                                    <div class="title font-weight-bold">{{
                                                                        headerCount.total }}</div>
                                                                </div>
                                                            </v-card>
                                                        </v-col>

                                                        <!-- Info Box 2 -->
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-card class="d-flex align-center pa-3">
                                                                <v-avatar size="40" class="mr-4" color="green">
                                                                    <v-icon dark>mdi-wifi</v-icon>
                                                                </v-avatar>
                                                                <div>
                                                                    <div class="subtitle-2">Online</div>
                                                                    <div class="title font-weight-bold">{{
                                                                        headerCount.online }}</div>
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-card class="d-flex align-center pa-3">
                                                                <v-avatar size="40" class="mr-2" color="orange">
                                                                    <v-icon dark>mdi-wifi-off</v-icon>
                                                                </v-avatar>
                                                                <div>
                                                                    <div class="subtitle-2">Suspend/Unpaid</div>
                                                                    <div class="title font-weight-bold">{{
                                                                        headerCount.suspend }}</div>
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                        <!-- Info Box 3 -->
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-card class="d-flex align-center pa-3">
                                                                <v-avatar size="40" class="mr-4" color="red">
                                                                    <v-icon dark>mdi-wifi-off</v-icon>
                                                                </v-avatar>
                                                                <div>
                                                                    <div class="subtitle-2">Offline</div>
                                                                    <div class="title font-weight-bold">{{
                                                                        headerCount.offline }}</div>
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>


                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <div class="col-sm-12 col-md-12">
                                        <v-data-table :headers="headers" :items="users" :loading="loading"
                                            :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                                            :server-items-length="totalItems"
                                            :footer-props="{ itemsPerPageOptions: [50, 100, 200] }"
                                            @update:page="fetchUsers" @update:items-per-page="changeItemsPerPage">
                                            <template #item.no="{ item, index }">
                                                {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                                            </template>
                                            <template #item.no_pelanggan="{ item }">
                                                <div class="text-center">
                                                    <IconWifi :status="item.status" />
                                                </div>
                                            </template>
                                            <template #item.total_invoice="{ item }">
                                                <div class="text-center">
                                                    {{ item.total_invoice }}
                                                </div>
                                            </template>
                                            <template #item.total_paid="{ item }">
                                                <div class="text-right">
                                                    {{ formatRupiah(item.total_paid) }}
                                                </div>
                                            </template>
                                            <template #item.bulan_pemakaian="{ item }">
                                                <div class="text-center">
                                                    {{ item.bulan_pemakaian }}
                                                </div>
                                            </template>
                                            <template #item.kantor="{ item }">
                                                <div class="text-left">
                                                    {{ item.kantor }}
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                            </v-main>
                        </v-app>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { formatRupiah } from '../../helpers/format'
import KantorCabang from '../../base-components/KantorCabang.vue'
import IconWifi from '../../base-components/IconWifi.vue'
import TextSearch from '../../base-components/TextSearch.vue'
export default {
    components: {
        KantorCabang,
        IconWifi,
        TextSearch
    },
    data() {
        return {
            filter: {
                kantor: null,
                status: null,
                search:null,
            },
            user: this.$gate.user,
            users: [],
            totalItems: 0,
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 50
            },
            headerCount: {
                online: 0,
                offline: 0,
                total: 0,
                suspend:0,
            },
            headers: [
                { text: '', value: 'no_pelanggan', sortable: true, width: '4%' },
                { text: 'User', value: 'username', sortable: false, width: '10%' },
                { text: 'Start', value: 'acctstarttime', sortable: false, class: 'text-center', width: '12%' },
                { text: 'Dow/MB', value: 'download_MB', sortable: false, class: 'text-center', width: '5%' },
                { text: 'Up/MB', value: 'upload_MB', sortable: false, class: 'text-center', width: '5%' },
                { text: 'ipaddress', value: 'framedipaddress', sortable: false, class: 'text-center', width: '10%' },
                { text: 'Mac address', value: 'mac_address', sortable: false, class: 'text-center', width: '10%' },
                { text: 'IP Nas', value: 'nasipaddress', sortable: false, class: 'text-center', width: '10%' },
                { text: 'Cabang', value: 'kantor', sortable: false, class: 'text-center', width: '10%' },
            ]
        }
    },
    mounted() {
        this.fetchUsers()
    },
    methods: {
        onFilterChange() {

            this.pagination.page = 1;
            this.fetchUsers();
        },
        formatRupiah,
        async fetchUsers() {
            this.loading = true
            try {
                const res = await axios.get('api/pppoe/users_online', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        kantor_id: this.filter.kantor?.id || null,
                        status: this.filter.status || null,
                        search:this.filter.search || null
                    }
                })

                this.users = res.data.data.data
                this.totalItems = res.data.data.total
                this.headerCount.online = res.data.count_online
                this.headerCount.offline = res.data.count_offline
                this.headerCount.suspend = res.data.count_suspend
                this.headerCount.total = parseInt(res.data.count_offline) + parseInt(res.data.count_online) + parseInt(res.data.count_suspend)
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchUsers()
        }
    }
}
</script>